export const CONTACTS = {
  phone: '(11) 96838-0592',
  email: 'contato@jsempregos.com.br',
  whatsapp: '5511968380592',
  address: 'São Paulo, SP — Brasil',
  businessHours: {
    weekday: 'Segunda a sexta: 08h às 18h',
    saturday: 'Sábados: Fechado',
    sunday: 'Domingos e feriados: Fechado',
  },
} as const;

export function getWhatsAppUrl(phoneNumber: string, message: string): string {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
}

export function getWhatsAppMessage(fields: Record<string, string>): string {
  const lines = Object.entries(fields)
    .filter(([, value]) => value)
    .map(([key, value]) => `*${key}:* ${value}`);
  return lines.join('\n');
}
